import React, { useContext, useState, Fragment } from "react";
import ConexContext from "../../context/ConexContext";
import { CSVLink } from "react-csv";
import { Modal, Col, ProgressBar } from "react-bootstrap";

import cerrar from "../../assets/img/cerrar.svg";
import csv from "../../assets/img/csv.svg";
import { formatNum } from "./formato";
import { copyObject } from "./copyObject";
// import { ExcelLink } from "../ExcelLink";

export const ExportCSV = ({ show, onHide, confs, date1, date2}) => {
	const conex=useContext(ConexContext);
    // const archivo_agregaciones=require('../../config/agregaciones.json');
	const archivo_agregaciones={
		"Sector":{
			"bd":"COALESCE(clase_actividad_eb.des_clase_activ,'Sin Identificar')",
		},	
		"Tarjeta":{
			"bd":"COALESCE(i6operacion.pan_mask,'Sin Identificar')",
		},
		"Comercio":{
			"bd":"COALESCE(i6operacion.nombre_comercio,'Sin Identificar')",
		},
		"Usuario":{
			"bd":"COALESCE(i6titular.nombre_titu,'Sin Identificar')",
		},
		"Departamento":{
			"bd":"COALESCE(i6departamento.nombre_dpto,'Sin Identificar')",
		},
		"Empresa":{
			"bd":"COALESCE(i6empresa.nombre_emp,'Sin Identificar')",
		},
		"Entidad":{
			"bd":"COALESCE(i6operacion.cod_ent,'Sin Identificar')",
		}
	}

	const [data, setData] = useState([]); // datos a exportar
	const [headers, setHeaders] = useState([]); // cabeceras de la tabla

	const [estado, setEstado] = useState(0);
	const [progres, setProgres] = useState(0);
	const [error, setError] = useState("");


    // devuelve la fecha en formato aaaammdd
    function fechaDB(date) {
        let s = date.getFullYear().toString().padStart(4, 0);
        s += (date.getMonth() + 1).toString().padStart(2, 0);
        s += date.getDate().toString().padStart(2, 0);
        return s;
    }

    // devuelve la fecha en formato dd/mm/aaaa de un valor aaaammdd
	function fechaMostrar(date) {
        let s = date.toString().substring(9, 6);
        s += "/" + date.toString().substring(6, 4);
        s += "/" + date.toString().substring(4, 0);
        return s;
    }

	const handleExport = async () => {
				setEstado(1);
				let nombresHeadersAux=confs.agregaciones;
				let headersCSVAux = [];
                nombresHeadersAux.forEach((campo) => {
                    headersCSVAux.push({
                        label: campo,
                        key: archivo_agregaciones[campo].bd,
                    });
                });
				let nombresHeaders=[];
				nombresHeadersAux.forEach((campo) => {
					nombresHeaders.push(archivo_agregaciones[campo].bd);
                });
				nombresHeaders.push("i6operacion.importe_liqui");
				nombresHeaders.push("i6operacion.fecha_ope");
				nombresHeaders.push("i6operacion.fecha_carga");
				nombresHeaders.push("i6operacion.pais_ori");
				nombresHeaders.push("i6operacion.pan_mask");
				nombresHeaders.push("i6titular.nombre_titu");
				nombresHeaders.push("i6titular.nif_titu");
				nombresHeaders.push("i6tipo_ope.nombre_ope");
				nombresHeaders.push("i6operacion.descripcion");

				let headersCSV=[];
				let headersCSVGeneral=[
					{label: "Importe", key: "i6operacion.importe_liqui"},
					{label: "Fecha de operación", key: "i6operacion.fecha_ope"},
					{label: "Fecha de carga", key: "i6operacion.fecha_carga"},
					{label: "País de origen", key: "i6operacion.pais_ori"},
					{label: "Nº de Tarjeta", key: "i6operacion.pan_mask"},
					{label: "Nombre de usuario", key: "i6titular.nombre_titu"},
					{label: "DNI", key: "i6titular.nif_titu"},
					{label: "Tipo de operación", key: "i6tipo_ope.nombre_ope"},
					{label: "Descripción", key: "i6operacion.descripcion"},
				]
				headersCSVAux.forEach((elemento)=>{
					headersCSV.push(elemento);
				})
				headersCSVGeneral.forEach((elemento)=>{
					headersCSV.push(elemento);
				})
                setProgres(50);
                setHeaders(headersCSV);

				//Consulta para todos los datos
				let query = {
					campos: copyObject(confs.campos),
					filtros_: copyObject(confs.filtros_),
					agregaciones: copyObject(confs.agregaciones),
					headers: nombresHeaders,
				};

                let res=await conex.peticion(`/resultadosparaCSV?fechainicio=${fechaDB(date1)}&fechafin=${fechaDB(date2)}`, {method:'POST',json:query});
                if(res?.estado??true) return
				let datosCSV = [];				
				let nombrecolumna=res["res"][0][archivo_agregaciones[confs.agregaciones[0]]["bd"]];
				let total=0.00;
				let guardarfila=false;
				let filaCSVgeneralUltima={};
				res["res"].forEach((fila) => {
					let filaCSV = {};	
					let filaCSVgeneral={};				
					nombresHeaders.forEach((columna) => {
						
						if(columna===archivo_agregaciones[confs.agregaciones[0]]["bd"]){
							if(nombrecolumna!==fila[columna]){
								guardarfila=true;
								filaCSVgeneral[columna]="TOTAL DE "+nombrecolumna;
								filaCSVgeneral["i6operacion.importe_liqui"]=formatNum(total, "€", ".", 2);
								nombrecolumna=fila[columna];
								total=0;		
							}	
						}

						if (columna==="i6operacion.importe_liqui"){
						    filaCSV[columna] = formatNum(fila[columna], "€", ".", 2);
							total= total+parseFloat(fila[columna]);
						}

						if (columna==="i6operacion.fecha_ope")
						    filaCSV[columna] = fechaMostrar(fila[columna]);
						if (columna==="i6operacion.fecha_carga")
						    filaCSV[columna] = fechaMostrar(fila[columna]);
					    if (columna!=="i6operacion.importe_liqui" && columna!=="i6operacion.fecha_ope" && columna!=="i6operacion.fecha_carga")
						    filaCSV[columna] = fila[columna];
					});

					if(guardarfila){
						datosCSV.push(filaCSVgeneral);
						guardarfila=false;
					}
					datosCSV.push(filaCSV);
				});
				filaCSVgeneralUltima["COALESCE(clase_actividad_eb.des_clase_activ,'Sin Identificar')"]="TOTAL DE "+nombrecolumna;
				filaCSVgeneralUltima["i6operacion.importe_liqui"]=formatNum(total, "€", ".", 2);
				datosCSV.push(filaCSVgeneralUltima);

				setData(datosCSV);
				setProgres(100);
				setEstado(2);
	};

	const handleCancel = () => {
		setEstado(0);
		setData([]);
		setHeaders([]);
		setProgres(0);
		setError("");
		onHide();
	};

	return (
		<Modal show={show} onHide={onHide} animation={false} centered className="generarcvs">
			<Modal.Body>
				<Col xs={12} className="contmodal fondoazul db1 modalcsv">
					<div className="contaspacierre">
						<div className="aspacierre">
							<img
								src={cerrar}
								alt="cerrar"
							
								onClick={() => {
									handleCancel();
								}}
								style={{ cursor: "pointer" }}
							/>
						</div>
					</div>
					<Col xs={12} className="titular_modal">
						<img src={csv} alt="generarcvs"/>
						Generar CSV
					</Col>
					<Col
						xs={12}				
					>
						{estado === 0 ? (
							<Fragment>
								<div className="titularcsv">
									<span>
										Vas a generar un documento CSV.
									</span>
								</div>						
							</Fragment>
						) : estado === 1 ? (
							<ProgressBar animated now={progres} />
						) : (
							<div className="botonessmodales">
								<CSVLink
									separator={";"}
									data={data}
									filename={"documento.csv"}
									target="_blank"
									headers={headers}
								>
									<div
										style={{
											width: "110px",
											height: "30px",
											fontSize: "1em",
											margin: "0px 10px",
											marginTop: "-5px",
										}}
										onClick={() => {}}
										className="downloadcsv"
									>
										Descargar CSV 
										<i className="fa-solid fa-download"></i>
									</div>
								</CSVLink>
								{/* <ExcelLink
								headers={headers}
								data={data}
								/> */}
							</div>
						)}
					</Col>
					<Col xs={12} className="subtitular_modal_error">
						{error}
					</Col>
					<Col xs={12} className="botonessmodales">
						{estado === 0 && (
							<>
								<button
									onClick={() => {
										handleCancel();
									}}
									className="cancelar grey"
								>
									Cancelar
								</button>
								<button
									onClick={() => {
										handleExport();
									}}
									className="generar"
								>
									Generar
								</button>
							</>
						)}
					</Col>
				</Col>
			</Modal.Body>
		</Modal>
	);
};
